module.exports = __webpack_public_path__ + "static/media/arrow_left.312e95d7.svg";